export default "__VITE_ASSET__D5a7IZfU__"